export interface AccountListMapperI {
  select: boolean;
  id: string;
  accountName: string;
  partnerType: string;
  shipState: string;
  phone: string;
  salesRep: string;
  productionManager: string;
  dateCreated: string;
  rating: string;
  csr: string;
  parentAccount: string;
  alternateAccountNumber: string;
  creditTerms:string;
  taxExempt: string;
  highCreditLimit: string;
  customerPo: string;
  firstOrderDate: string;
  leadSource: string;
  industry: string;
  pricingMethods: string;
  corporateIdentityName: string;
  accountType: string;
  accountExtension: string;
  vendorAccountNumber: string;
  defaultCurrency: string;
  taxExemptCertExpDate: string;
}
